import I18n from 'i18n-js';
import { ActionType } from './sellerListingCardReducer';
import { ISellerListingCardContext } from './SellerListingCardContext';

function checkResponse(
  res,
) {
  return {
    hasErrors: !!res.errors?.length,
    hasData: !!res.data,
  };
}

export default async function refetchCardListing(listingCardContext: ISellerListingCardContext) {
  const { cardState, dispatch: cardStateDispatch, listingQuery } = listingCardContext;
      
  const [
    queryListing,
  ] = listingQuery;
      
  cardStateDispatch({
    type: ActionType.SET_LOADING_LISTING,
    payload: {
      loadingListing: true,
    },
  });
    
  try {
    const res = await queryListing({
      variables: {
        id: cardState.listing.id,
      },
    });

    const { hasErrors, hasData } = checkResponse(res);

    if (hasErrors || !hasData) {
      throw new Error();
    }
    
    cardStateDispatch({
      type: ActionType.SET_LISTING,
      payload: {
        listing: res.data.listing,
      },
    });
  } catch (error) {
    cardStateDispatch({
      type: ActionType.SHOW_TOAST,
      payload: {
        isSuccess: false,
        message: I18n.t(
          'discovery.listingsManagement.sellerListingCard.listingFetchFail',
        ),
      },
    });
  }
    
  cardStateDispatch({
    type: ActionType.SET_LOADING_LISTING,
    payload: {
      loadingListing: false,
    },
  });
}
